import { currencyOptions } from "@/common/const";
import {
  maintenanceSLAOptions,
  includedOptions,
} from "@/common/const/filter-options";
import maintenanceTypeOptions from "@/common/const/filter-options/maintainanceType.options";
import quoteCreationTypeOptions from "@/common/const/quote/quoteCreationTypes.const";
import { contractTermsOptions } from "@/common/const/types/index.const";
import { FormFieldsStrategyType } from "@/common/types";

const hardwareQuoteLineFormStrategy: FormFieldsStrategyType[] = [
  {
    label: "Currency",
    name: "currency",
    readonly: true,
    required: true,
    inputType: "select",
    options: currencyOptions,
  },
  {
    inputType: "text",
    label: "OTE",
    name: "OTE",

    required: true,
  },
  {
    inputType: "text",
    label: "MRE",
    name: "MRE",
    required: true,
  },
  {
    inputType: "select",
    label: "Quote Type",
    required: false,
    readonly: false,
    name: "quoteType",
    options: quoteCreationTypeOptions,
  },
  {
    inputType: "text",
    label: "OEM/Manufaturer Name",
    name: "manufaturerName",
    required: true,
  },
  {
    inputType: "text",
    label: "Product Code/Part Number",
    name: "productCode",
    required: true,
  },

  {
    inputType: "select",
    label: "Purchase Type",
    name: "purchaseType",
    required: true,
    options: [
      { label: "Resale", value: "Resale" },
      {
        label: "Rental",
        value: "Rental",
      },
    ],
  },

  {
    inputType: "select",
    label: "Contract Term",
    name: "contractTerm",
    required: true,
    options: [...contractTermsOptions],
  },

  {
    inputType: "select",
    label: "Local Tax/VAT*",
    name: "isLocalTax",
    required: true,
    options: includedOptions,
  },
  {
    inputType: "text",
    label: "Local Tax/VAT (in %)",
    name: "localTax",
    required: true,
  },
  {
    inputType: "select",
    label: "Maintenance Type",
    name: "maintenanceType",
    required: true,
    options: maintenanceTypeOptions,
  },
  {
    inputType: "select",
    label: "Maintenance SLA",
    name: "maintenanceSla",
    required: true,
    options: maintenanceSLAOptions,
  },
  {
    inputType: "select",
    label: "Maintenance Status",
    name: "maintenanceStatus",
    required: true,
    options: includedOptions,
  },
  {
    inputType: "text",
    label: "License Name",
    name: "licenseName",
    required: true,
  },
  {
    inputType: "select",
    label: "License Status",
    name: "licenseStatus",
    required: true,
    options: includedOptions,
  },
  {
    inputType: "text",
    label: "Lead Time (in Days)",
    name: "leadTeam",
    required: true,
  },
  {
    inputType: "select",
    label: "On-site Delivery Included",
    name: "onSiteDeliveryIncluded",
    required: true,
    options: includedOptions,
  },
  {
    inputType: "select",
    label: "On-site Installation Included",
    name: "onSiteInstallationIncluded",
    required: true,
    options: includedOptions,
  },
  {
    inputType: "select",
    label: "Custom/Duties Included",
    name: "dutiesIncluded",
    required: true,
    options: includedOptions,
  },
  {
    inputType: "select",
    label: "Network Status",
    name: "networkStatus",
    required: false,
    options: [
      {
        label: "Off Net",
        value: "OfNet",
      },
      {
        label: "Near Net",
        value: "NearNet",
      },
      {
        label: "On Net",
        value: "OnNet",
      },
    ],
  },
  {
    inputType: "select",
    label: "The source of the price",
    name: "source",
    required: false,
    readonly: true,
    options: [
      {
        label: "Manual",
        value: "manual",
      },
      {
        label: "Building List",
        value: "BuildingList",
      },
      {
        label: "Country Coverage",
        value: "CountryCoverage",
      },
    ],
  },
  {
    inputType: "textarea",
    label: "Note",
    name: "description",
    required: false,
  },
];
export default hardwareQuoteLineFormStrategy;
